export default __webpack_public_path__ + "static/media/view.fb18b7bc.png";